var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawCanvas",style:({ backgroundImage: `url(${_vm.myImage})` })},[_c('img',{staticClass:"illustrationImage",attrs:{"src":_vm.illustrationImage,"alt":_vm.illustrationDescription}})])
}
var staticRenderFns = []

export { render, staticRenderFns }